import { MatchEvent, Match } from './entities';

export class ClipData {
  constructor(
    public clips: MatchEvent[],
    public match: Match,
    public name: string,
    public playlistId?: string
  ) {}
}

export class Clip {
  isPlaying = false;
  constructor(
    public name: string,
    public seconds: number,
    public leadSeconds: number,
    public lagSeconds: number,
    public comments: string
  ) {}
}
